// import Cnpj from '@/views/signUp/Cnpj'
// import AlreadyRegistered from '@/views/signUp/AlreadyRegistered'
// import CompanyLocated from '@/views/signUp/CompanyLocated'
// import Invitation from '@/views/signUp/Invitation'
// import SignUpPage from '@/views/signUp/SignUp'
// import EmailConfirm from '@/views/signUp/EmailConfirm'
// import Password from '@/views/signUp/Password'
// import NewPassword from '@/views/signUp/NewPassword'
// import Index from '@/views/NotSidebar'
const Cnpj = () => import('@/views/signUp/Cnpj');
const AlreadyRegistered = () => import('@/views/signUp/AlreadyRegistered');
const CompanyLocated = () => import('@/views/signUp/CompanyLocated');
const Invitation = () => import('@/views/signUp/Invitation');
const SignUpPage = () => import('@/views/signUp/SignUp');
const EmailConfirm = () => import('@/views/signUp/EmailConfirm');
const Password = () => import('@/views/signUp/Password');
const NewPassword = () => import('@/views/signUp/NewPassword');
const Index = () => import('@/views/NotSidebar');
import getWhiteLabel from '@/utils/getWhiteLabel'

const signupRouter = {
    path: '/signup',
    component: Index,
    name: 'signup',
    meta: {
        requiresAuth: false
    },
    children: [
        {
            name: 'signup',
            path: '/',
            component: Cnpj,
            meta: {
                title: `${getWhiteLabel()} | Cadastre-se`,
                requiresAuth: false
            },
        },
        {
            name: 'alreadyregistered',
            path: 'alreadyregistered',
            component: AlreadyRegistered,
            meta: {
                title: `${getWhiteLabel()} | Cadastre-se`,
                requiresAuth: false
            },
        },
        {
            name: 'located',
            path: 'located',
            component: CompanyLocated,
            meta: {
                title: `${getWhiteLabel()} | Cadastre-se`,
                requiresAuth: false
            },
        },
        {
            name: 'user',
            path: 'user',
            component: SignUpPage,
            meta: {
                title: `${getWhiteLabel()} | Cadastre-se`,
                requiresAuth: false
            },
        },
        {
            name: 'invite',
            path: 'invite',
            component: Invitation,
            meta: {
                title: `${getWhiteLabel()} | Cadastre-se`,
                requiresAuth: false
            },
        },
        {
            name: 'emailconfirm',
            path: 'emailconfirm',
            component: EmailConfirm,
            meta: {
                title: `${getWhiteLabel()} | Cadastre-se`,
                requiresAuth: false
            },
        },
        {
            name: 'password',
            path: 'password/:token',
            component: Password,
            meta: {
                title: `${getWhiteLabel()} - Cadastre-se`,
                requiresAuth: false
            },
        },
        {
            name: 'password',
            path: 'password',
            component: NewPassword,
            meta: {
                title: `${getWhiteLabel()} - Cadastre-se`,
                requiresAuth: false
            },
        },
    ]


}

export default signupRouter;